import AppDataService from "./AppDataService";

const COMMON_BASE = "Reconciliation"

export default class ReconciliationDataService {

    static async getReconciliationPayers() {
        return await AppDataService.get(`${COMMON_BASE}/GetPayers`);
    }

    static async getReconciliationTaxYears() {
        return await AppDataService.get(`${COMMON_BASE}/GetTaxYears`);
    }

    static async getReconciliationStates(payerId) {
        return await AppDataService.get(`${COMMON_BASE}/GetReconciliationStates?Payerid=${payerId}`);
    }

    static async getReconciliationListData(data) {
        return await AppDataService.get(`${COMMON_BASE}/GetReconciliationdata?Payerid=${data.Payerid}&taxYear=${data.taxYear}&state=${data.state}&PageNumber=${data.PageNumber}&PageSize=${data.PageSize}`);
    }

    static async getSubmitReconciliationListRecords(data) {
        return await AppDataService.get(`${COMMON_BASE}/GetReconciliationGrid?Payerid=${data.Payerid}&PageSize=${data.PageSize}&PageNumber=${data.PageNumber}&taxYear=${data.taxYear}&state=${data.state}&referenceNumber=${data.referenceNumber}&formName=${data.formName}`);
    }

    static async getFormFields(formName, quarter) {
        let quarterParam = "";
        if(quarter !== ""){
            quarterParam = `&quarter=${quarter}`;
        }
        return await AppDataService.get(`${COMMON_BASE}/GetFormFields?formName=${formName}${quarterParam}`);
    }

    static async getReconciliationPreloadedData(formName, payerId, taxYear, referenceid, state, quarter) {
        let quarterParam = "";
        if(quarter !== ""){
            quarterParam = `&quarter=${quarter}`;
        }
        return await AppDataService.get(`${COMMON_BASE}/GetFormData?recFormName=${formName}&payerId=${payerId}&taxYear=${taxYear}&referenceid=${referenceid}&state=${state}${quarterParam}`);
    }

    static async getFormByRecordId(formName, formRecordId) {
        return await AppDataService.get(`${COMMON_BASE}/GetForm?FormName=${formName}&formRecordId=${formRecordId}`);
    }

    static async calculateInferredValues(formData) {
        return await AppDataService.post(`${COMMON_BASE}/CalculateInferredValues`, formData);
    }

    static async saveReconciliation(formData) {
        return await AppDataService.post(`${COMMON_BASE}/Save`, formData);
    }

    static async getReconciliationPDF(formId, state, formName) {
        return await AppDataService.get(`${COMMON_BASE}/GetReconciliationPDF?reconFormId=${formId}&reconState=${state}&formName=${formName}`);
    }

    static async getReconciliationAmount(payerId, referenceIds, formName, state, reconciliationFormId, taxYear) {
        return await AppDataService.get(`${COMMON_BASE}/ReconciliationAmount?payerId=${payerId}&referenceIds=${referenceIds}&formName=${formName}&state=${state}&reconciliationFormId=${reconciliationFormId}&taxYear=${taxYear}`);
    }

    static async submitReconciliationPayment(data) {
        return await AppDataService.post(`${COMMON_BASE}/ReconciliationPayment`, data)
    }

    static async getReconciliationUnSubmittedFormsExportToExcel() {
        return await AppDataService.get(`${COMMON_BASE}/ReconciliationUnSubmittedFormsExportToExcel`);
    } 

    static async getReconFrequencyPopUpOption(state = null, reconFormid = null) {
        let reConFrequencyParamUrl = "";
        if(state && reconFormid){
            reConFrequencyParamUrl = `?state=${state}&reconFormid=${reconFormid}`
        }
        return await AppDataService.get(`${COMMON_BASE}/GetReconPopUp${reConFrequencyParamUrl}`);
    } 

    static async checkIfSelectedFormsCombinationAllowed(state, formNames){
        return await AppDataService.get(`${COMMON_BASE}/AllowReconciliation?state=${state}&formName=${formNames}`);
    }
}